export default "__VITE_PUBLIC_ASSET__80617f83__"